import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { passing_draw_polygon as passingDrawPolygon } from "mapbox-gl-draw-passing-mode";

const {
  lib: { CommonSelectors, isEventAtCoordinates },
} = MapboxDraw;

export const SELECTION_DRAW_POLYGON = "selection_draw_polygon";

const MIN_VERTICES = 3;

/**
 * Returns true if the event is a gesture that would complete the polygon:
 * clicking an existing vertex or re-clicking the previously placed point.
 */
function isFinishGesture(state: any, e: MapboxDraw.MapMouseEvent | MapboxDraw.MapTouchEvent): boolean {
  return (
    CommonSelectors.isVertex(e) ||
    (state.currentVertexPosition > 0 &&
      isEventAtCoordinates(e as MapboxDraw.MapMouseEvent, state.polygon.coordinates[0][state.currentVertexPosition - 1]))
  );
}

function handleClick(this: MapboxDraw.DrawCustomModeThis, state: any, e: MapboxDraw.MapMouseEvent | MapboxDraw.MapTouchEvent) {
  if (isFinishGesture(state, e) && state.currentVertexPosition < MIN_VERTICES) return;
  passingDrawPolygon.onClick?.call(this, state, e);
}

/**
 * Extends the passing_draw_polygon mode to only complete valid polygons.
 *
 * Finish gestures (clicking a vertex, re-clicking the previous point, or
 * pressing Enter) are ignored until the polygon has three vertices.
 */
const selectionDrawPolygon: DrawCustomMode = {
  ...passingDrawPolygon,

  onClick: handleClick,

  onTap: handleClick,

  onKeyUp(state, e) {
    if (CommonSelectors.isEnterKey(e) && state.currentVertexPosition < MIN_VERTICES) return;
    passingDrawPolygon.onKeyUp?.call(this, state, e);
  },

  onStop(state) {
    if (this.getFeature(state.polygon.id) !== undefined) {
      state.polygon.removeCoordinate(`0.${state.currentVertexPosition}`);
    }
    passingDrawPolygon.onStop?.call(this, state);
  },
};

export default selectionDrawPolygon;
